import { TItem } from '../types/items.types';
/**
 * Extracts the second element of the path array, which represents the jurisdiction ID.
 * Logs an error if the jurisdiction ID is missing.
 *
 * @param item - The item object containing a path array.
 * @returns The jurisdiction ID if available, otherwise `undefined`.
 */
const getJurisdictionId = (item: TItem): string | undefined => {
  if (item.path.length < 2) {
    console.error('Error: Jurisdiction ID is undefined. The path array has less than two elements.', item);
    return undefined;
  }
  return item.path[1];
};
export default getJurisdictionId;
